import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wishlist-icon" }

import { onMounted, ref } from 'vue'

declare global {
  interface Window {
    addWishlist?: (itemNumber: string, image: string, linkItemNumber: string) => void,
    removeWishlist?: (linkItemNumber: string) => void,
    hasWishlist?: (linkItemNumber: string) => boolean
  }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'wishlistIcon',
  props: {
    itemNumber: {},
    image: {},
    linkItemNumber: {}
  },
  setup(__props: any) {

const props = __props;

const isOnWishlist = ref(false)

const checkItemIsOnWishlist = () => {
  isOnWishlist.value = window?.hasWishlist ? window?.hasWishlist(props.linkItemNumber) : false
}

const addToWishList = () => {
  if (window?.addWishlist) {
    window?.addWishlist(props.itemNumber, props.image, props.linkItemNumber)
    isOnWishlist.value = true
  }
}

const toggleItemOnWishList = () => {
  if (isOnWishlist.value) {
    if (window?.removeWishlist) {
      window?.removeWishlist(props.linkItemNumber)
      isOnWishlist.value = false
    }
  } else {
    addToWishList()
  }
}

onMounted(() => {
  checkItemIsOnWishlist()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isOnWishlist.value)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          onClick: _withModifiers(toggleItemOnWishList, ["stop","prevent"]),
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          "stroke-width": "1.5",
          stroke: "currentColor",
          class: "w-6 cursor-pointer text-brand-main"
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
          }, null, -1)
        ]))]))
      : (_openBlock(), _createElementBlock("svg", {
          key: 1,
          onClick: _withModifiers(toggleItemOnWishList, ["stop","prevent"]),
          xmlns: "http://www.w3.org/2000/svg",
          fill: "currentColor",
          viewBox: "0 0 24 24",
          "stroke-width": "1.5",
          stroke: "currentColor",
          class: "w-6 cursor-pointer text-brand-main"
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
          }, null, -1)
        ]))]))
  ]))
}
}

})